// PCL2 版本数据管理
// 统一管理所有版本的下载信息、发布日期等数据

const PCL2_DATA = {
    // 当前最新版本信息
    latest: {
        version: "2.10.9",
        releaseDate: "2025-10-08",
        downloadUrl: "https://pan.quark.cn/s/d7e6f92cfe07"
    },

    // 所有版本列表（按发布时间倒序）
    versions: [
        {
            version: "2.10.9",
            author: "龙腾猫跃",
            releaseDate: "2025-10-08",
            downloadUrl: "https://pan.quark.cn/s/d7e6f92cfe07",
            fileName: "PCL_正式版_2.10.9.rar",
            changelog: "修复了一些已知问题，优化了用户体验。"
        },
        {
            version: "2.10.8",
            author: "龙腾猫跃",
            releaseDate: "2025-09-13",
            downloadUrl: "https://pan.quark.cn/s/11922ff6a018",
            fileName: "PCL_正式版_2.10.8.rar",
            changelog: "更新了核心下载引擎，提升了资源下载速度。"
        },
        {
            version: "2.10.6",
            author: "龙腾猫跃",
            releaseDate: "2025-08-13",
            downloadUrl: "https://pan.quark.cn/s/6e1d2c7ddf02",
            fileName: "PCL_正式版_2.10.6.rar"
        },
        {
            version: "2.10.5",
            author: "龙腾猫跃",
            releaseDate: "2025-08-07",
            downloadUrl: "https://pan.quark.cn/s/9dbe4c48b925",
            fileName: "PCL_正式版_2.10.5.rar"
        },
        {
            version: "2.10.3",
            author: "龙腾猫跃",
            releaseDate: "2025-06-17",
            downloadUrl: "https://pan.quark.cn/s/5b8d9bc81bd4",
            fileName: "PCL_正式版_2.10.3.rar"
        },
        {
            version: "2.10.2",
            author: "龙腾猫跃",
            releaseDate: "2025-06-17",
            downloadUrl: "https://pan.quark.cn/s/7dc5c62383a4",
            fileName: "PCL_正式版_2.10.2.rar"
        },
        {
            version: "2.10.0",
            author: "龙腾猫跃",
            releaseDate: "2025-05-04",
            downloadUrl: "https://pan.quark.cn/s/b0c592cbd4f1",
            fileName: "PCL_正式版_2.10.0.rar"
        },
        {
            version: "2.9.3",
            author: "龙腾猫跃",
            releaseDate: "2025-04-05",
            downloadUrl: "https://pan.quark.cn/s/dfa9aa4d7593",
            fileName: "PCL_正式版_2.9.3.rar"
        },
        {
            version: "2.9.1",
            author: "龙腾猫跃",
            releaseDate: "2025-02-22",
            downloadUrl: "https://pan.quark.cn/s/6ef5f989ed4d",
            fileName: "PCL_正式版_2.9.1.rar"
        },
        {
            version: "2.8.13",
            author: "龙腾猫跃",
            releaseDate: "2025-01-27",
            downloadUrl: "https://pan.quark.cn/s/ccc6facef200",
            fileName: "PCL_正式版_2.8.13.rar",
            bilibiliUrl: "https://www.bilibili.com/opus/1026112998934052866"
        },
        {
            version: "2.8.12",
            releaseDate: "2025-01-23",
            downloadUrl: "https://pan.quark.cn/s/a2962b9fd8c6",
            fileName: "PCL_正式版_2.8.12.rar",
            bilibiliUrl: "https://www.bilibili.com/opus/1010399693571620864"
        }
    ],

    // 下载渠道信息
    downloadChannels: {
        lanzou: {
            name: "蓝奏云下载",
            description: "密码：pcl2",
            password: "pcl2",
            url: "https://dahkk.lanzoul.com/b00rokff7a",
            icon: "fas fa-download"
        },
        quark: {
            name: "夸克网盘",
            description: "不限速体验",
            url: "https://pan.quark.cn/s/d7e6f92cfe07",
            icon: "fas fa-cloud-download-alt"
        }
    }
};

// 工具函数
const PCL2_UTILS = {
    // 获取最新版本信息
    getLatestVersion() {
        return PCL2_DATA.latest;
    },

    // 根据版本号获取版本信息
    getVersionInfo(version) {
        return PCL2_DATA.versions.find(v => v.version === version);
    },

    // 获取所有版本列表
    getAllVersions() {
        return PCL2_DATA.versions;
    },

    // 格式化日期显示
    formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('zh-CN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    },

    // 生成版本列表HTML
    generateVersionListHTML() {
        return PCL2_DATA.versions.map(version => {
            const authorHTML = version.author ? 
                `<span><i class="fas fa-user-edit mr-1.5"></i>${version.author}</span>` : '';
            
            const bilibiliHTML = version.bilibiliUrl ? 
                `<a href="${version.bilibiliUrl}" target="_blank" style="color: #fb7299; font-size: 0.8rem; margin-top: 0.2rem; display: block;"><i class="fab fa-bilibili"></i> 查看动态</a>` : '';

            return `
                <div class="version-item">
                    <div class="version-info">
                        <h4>PCL_正式版_${version.version}</h4>
                        <div class="version-meta">
                            ${authorHTML}
                            <span><i class="far fa-calendar-alt mr-1.5"></i>${version.releaseDate}</span>
                        </div>
                        ${bilibiliHTML}
                    </div>
                    <a href="${version.downloadUrl}" target="_blank" class="btn-download-sm">下载地址</a>
                </div>
            `;
        }).join('');
    },

    // 生成更新日志HTML
    generateChangelogHTML() {
        const recentVersions = PCL2_DATA.versions.filter(v => v.changelog).slice(0, 3);
        
        return recentVersions.map(version => `
            <div class="border-l-2 border-white/10 pl-4">
                <h4 class="text-white mb-2">${version.releaseDate} (v${version.version})</h4>
                <p>${version.changelog}</p>
            </div>
        `).join('');
    },

    // 生成下载区域HTML
    generateDownloadGridHTML() {
        const channels = PCL2_DATA.downloadChannels;
        
        return Object.values(channels).map(channel => {
            const subtitleHTML = channel.password ? 
                `密码： <span class="download-link-password copyable" data-copy="${channel.password}">${channel.password}</span>` : 
                channel.description;

            return `
                <a href="${channel.url}" target="_blank" class="download-link">
                    <div class="download-link-info">
                        <span class="download-link-title">${channel.name}</span>
                        <span class="download-link-subtitle">${subtitleHTML}</span>
                    </div>
                    <div class="download-link-icon">
                        <i class="fas fa-arrow-down"></i>
                    </div>
                </a>
            `;
        }).join('');
    },

    // 更新页面中的动态内容
    updatePageContent() {
        // 更新Hero区域的版本信息
        const heroVersion = document.querySelector('.hero-badge');
        if (heroVersion) {
            heroVersion.innerHTML = `
                <span class="hero-badge-dot"></span>
                Stable Release ${PCL2_DATA.latest.version}
            `;
        }

        // 更新下载区域的版本信息
        const downloadVersion = document.querySelector('.download-version');
        if (downloadVersion) {
            const latestDate = this.formatDate(PCL2_DATA.latest.releaseDate);
            downloadVersion.textContent = `当前版本: ${PCL2_DATA.latest.version} | 更新于: ${latestDate}`;
        }

        // 更新版本列表
        const versionList = document.querySelector('.version-list');
        if (versionList) {
            versionList.innerHTML = this.generateVersionListHTML();
        }

        // 更新更新日志
        const changelogContent = document.querySelector('#changelog .flex.flex-col.gap-6');
        if (changelogContent) {
            const changelogHTML = this.generateChangelogHTML();
            const moreLogsHTML = `
                <div class="text-center pt-4">
                    <span class="opacity-50">更多日志请查看版本历史</span>
                </div>
            `;
            changelogContent.innerHTML = changelogHTML + moreLogsHTML;
        }

        // 更新下载区域
        const downloadGrid = document.querySelector('.download-grid');
        if (downloadGrid) {
            downloadGrid.innerHTML = this.generateDownloadGridHTML();
        }

        // 更新 JSON-LD 结构化数据中的版本信息
        const jsonLdScript = document.querySelector('script[type="application/ld+json"]');
        if (jsonLdScript) {
            try {
                const jsonData = JSON.parse(jsonLdScript.textContent);
                jsonData.softwareVersion = PCL2_DATA.latest.version;
                jsonLdScript.textContent = JSON.stringify(jsonData, null, 2);
            } catch (e) {
                console.warn('Failed to update JSON-LD data:', e);
            }
        }
    }
};

// 页面加载完成后自动更新内容
document.addEventListener('DOMContentLoaded', function() {
    PCL2_UTILS.updatePageContent();
});

// 导出数据和工具函数（如果需要在其他文件中使用）
if (typeof module !== 'undefined' && module.exports) {
    module.exports = { PCL2_DATA, PCL2_UTILS };
}
